module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "src": "javascript:;"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('img', {
    attrs: {
      "src": "/static/img/footer/footer-button.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "src": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.link1))])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "src": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.link2))])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "src": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.link3))])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "src": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.link4))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee87f466!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooterText.vue
// module id = 175
// module chunks = 1